import React from "react";
import { SliderControlSettingsModel } from "../model/slider-control.settings.model";
import { OptionRangeModelArray } from "../model/option-range.model";
import { QqControlPropsType } from "./qq-control-props.type";
import { sliderAction } from "../message-interop/control-actions/slider.action";

export const QqSliderControlRaw: React.FunctionComponent<
  QqControlPropsType<SliderControlSettingsModel, OptionRangeModelArray>
> = ({ qq, dispatch }) => {
  if (qq.visible !== undefined && !qq.visible) return <span />;
  return (
    <div>
      <label htmlFor={qq.key}>{qq.text}</label>
      <input
        type="text"
        id={qq.key}
        name={qq.key}
        onChange={(e) => dispatch(sliderAction(qq, parseInt(e.target.value)))}
      />
    </div>
  );
};
